import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../util/cookie/cookies";

export const PromotionNaviBox = () => {
    const lang = getCookie('HYUNDAILANG')
    const location = useLocation()
    const pathname = location.pathname
    const navigate = useNavigate()
    return(
        <>
        <ul className="tabBtnBox">
            <li className={pathname === '/prCenter/promotion/catalogue' ? 'active' : ""} onClick={()=>navigate('/prCenter/promotion/catalogue?page=1')}>
                {lang==='kr'?'카탈로그':'Catalogue'}
            </li>
            <li className={pathname === '/prCenter/promotion/video' ? 'active' : ""}  onClick={()=>navigate('/prCenter/promotion/video')}>
                {lang==='kr'?'홍보영상':'Promotional video'}
            </li>
        </ul>
        </>
    )
}